import type {QuestionDb} from '@cp/model';
import {COLLECTION_EXAM_MODULE, SUBCOLLECTION_QUESTION} from '@cp/model';
import {collection, CollectionReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export default function getQuestionCollectionRef(moduleId: string): CollectionReference<QuestionDb> {
  return collection(
    firebaseFirestore,
    COLLECTION_EXAM_MODULE,
    moduleId,
    SUBCOLLECTION_QUESTION,
  ) as CollectionReference<QuestionDb>;
}
